import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type PriceWithLabelStylesClasses = 'price' | 'cachePrice' | 'label' | 'icon' | 'container';

const priceWithLabelStyles = makeStyles<ISpcTheme, PriceWithLabelStylesClasses>(
  ({ palette, typography, breakpoints }) => ({
    container: {
      width: 'max-content',
      marginLeft: '16px',
      [breakpoints.down('md')]: {
        padding: '0px 5px',
      },
      [breakpoints.down('sm')]: {
        maxWidth: '140px',
        padding: '0px 2px',
        margin: 0,
      },
    },
    price: {
      fontFamily: typography.fontFamily,
      color: palette.primary.main,
      fontSize: typography.fontLG,
      fontWeight: typography.fontWeightBold,
      lineHeight: '24px',
    },
    cachePrice: {},
    label: {
      textAlign: 'center',
      lineHeight: '14px',

      [breakpoints.down('xs')]: {
        lineHeight: '16px',
      },
    },
    icon: {},
  }),
  { name: 'Customise_PriceWithLabel' },
);

export default priceWithLabelStyles;
